import { NavLink } from 'react-router-dom';
import { themePalette } from '@theme/muiTheme';
import styled from 'styled-components';

export const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: inherit;
`;

interface NavLinkContentProps {
  $isActive?: boolean;
}

export const NavLinkContent = styled('div')<NavLinkContentProps>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background-color: ${(p) =>
    p.$isActive ? themePalette.grey[500] : 'inherit'};
`;
